
export default {
  props: {
    blok: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  computed: {
    isMobile() {
      return process.client && (window?.innerWidth || 769) <= 768
    },
    backgroundImageStyle() {
      const image = this.isMobile ? this.blok.mobile_background : this.blok.background
      return `url('${image.filename}')`
    }
  }
}
